function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { GetItContext } from "../../base/provider/GetItContext";
import { NodesUtil } from "../NodesUtil";
import { Button } from "antd";
import { BrainClient } from "imagica-corekit/dist/base/api/BrainClient";
import { tryPromise } from "imagica-corekit/dist/base/cutil/LangUtil";
import { Analytics } from "imagica-corekit/dist/base/port/Analytics";
import React, { useContext, useRef } from "react";
import useState from "react-usestateref";
import styles from "./InterviewBot.module.scss";
function MakeACall(props) {
  var getIt = useContext(GetItContext);
  var brainClient = getIt(BrainClient);
  var analytics = getIt(Analytics);
  var edgeDataLoading = props.edgeDataLoading,
    AIDesc = props.AIDesc,
    msg = props.msg;
  var currentAIDescRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 3),
    setPreambleLoading = _useState4[1],
    preambleLoadingRef = _useState4[2];
  var _useState5 = useState(""),
    _useState6 = _slicedToArray(_useState5, 2),
    preamble = _useState6[0],
    setPreamble = _useState6[1];
  var _useState7 = useState(""),
    _useState8 = _slicedToArray(_useState7, 2),
    phoneNumber = _useState8[0],
    setPhoneNumber = _useState8[1];
  var _useState9 = useState("Hi how's your day going?"),
    _useState10 = _slicedToArray(_useState9, 2),
    intro = _useState10[0],
    setIntro = _useState10[1];
  var handleChangePhoneNumber = function handleChangePhoneNumber(e) {
    setPhoneNumber(e.target.value);
  };
  var handleChangeIntro = function handleChangeIntro(e) {
    setIntro(e.target.value);
  };
  var handleClickMakeACall = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var preambleParams;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (AIDesc) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return", NodesUtil.message({
              content: "Need input what do you want the AI to do",
              type: "warning"
            }));
          case 2:
            if (phoneNumber) {
              _context.next = 4;
              break;
            }
            return _context.abrupt("return", NodesUtil.message({
              content: "Need input the phone number",
              type: "warning"
            }));
          case 4:
            if (intro) {
              _context.next = 6;
              break;
            }
            return _context.abrupt("return", NodesUtil.message({
              content: "Need input the intro",
              type: "warning"
            }));
          case 6:
            setLoading(true);
            preambleParams = preamble;
            if (preambleLoadingRef.current === true) {
              // await (async () => {
              //   return new Promise(resolve => {
              //     let time = 0;
              //     let timer = setInterval(() => {
              //       time = time + 100;
              //       if (preambleLoadingRef.current === false) {
              //         clearInterval(timer);
              //         resolve("Successfully fetched");
              //       }
              //       // If it exceeds 5 seconds, force a stop to avoid a dead cycle
              //       if (time >= 5 * 1000) {
              //         clearInterval(timer);
              //         resolve("Failed fetched");
              //       }
              //     }, 100);
              //   });
              // })();
            }

            // If user reenter the `AI desc` or there is no preamble, fetch the preamble data
            _context.next = 11;
            return fetchPreambleData();
          case 11:
            preambleParams = _context.sent;
            _context.next = 14;
            return initConversation(preambleParams);
          case 14:
            analytics.logEvent("interview_bot_make_call", {
              prompt: preambleParams,
              phone_number: phoneNumber,
              intro: intro
            });
            setLoading(false);
          case 16:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleClickMakeACall() {
      return _ref.apply(this, arguments);
    };
  }();
  var initConversation = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(preambleParams) {
      var result;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return tryPromise(brainClient.openAi.conversation({
              to: phoneNumber,
              preamble: preambleParams,
              intro: intro
            }));
          case 2:
            result = _context2.sent;
            if (!result.error) {
              _context2.next = 7;
              break;
            }
            NodesUtil.message({
              content: "Failed to make a call",
              type: "warning"
            });
            console.error("Failed to make a call", result.error);
            return _context2.abrupt("return");
          case 7:
            NodesUtil.message({
              content: "Call placed successfully",
              type: "success"
            });
          case 8:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function initConversation(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var fetchPreambleData = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var _result$data;
      var input,
        result,
        temp,
        _args3 = arguments;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            input = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : AIDesc;
            setPreambleLoading(true);
            _context3.next = 4;
            return tryPromise(brainClient.openAi.instantIntent({
              domain: "brain_studios",
              model_params: "brain_studios_xxx_interview_agent_prompt_generation.model"
            }));
          case 4:
            result = _context3.sent;
            setPreambleLoading(false);
            if (!result.error) {
              _context3.next = 10;
              break;
            }
            console.error(result.error);
            // If fetch failed, use `AIDesc`
            setPreamble(AIDesc);
            return _context3.abrupt("return", AIDesc);
          case 10:
            temp = (((_result$data = result.data) === null || _result$data === void 0 ? void 0 : _result$data.data.prompt) || "") + "\n" + input;
            currentAIDescRef.current = input;
            setPreamble(temp);
            return _context3.abrupt("return", temp);
          case 14:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function fetchPreambleData() {
      return _ref3.apply(this, arguments);
    };
  }();

  // useEffect(() => {
  //   if (edgeDataLoading) {
  //     fetchPreambleData(msg);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [edgeDataLoading]);

  return /*#__PURE__*/React.createElement("div", {
    className: styles.form
  }, /*#__PURE__*/React.createElement("label", {
    className: styles.label
  }, "Phone number"), /*#__PURE__*/React.createElement("input", {
    type: "text",
    onFocus: function onFocus() {
      return props.onFocus();
    },
    onChange: handleChangePhoneNumber,
    className: styles.input
  }), /*#__PURE__*/React.createElement("label", {
    className: styles.label
  }, "Intro"), /*#__PURE__*/React.createElement("input", {
    type: "text",
    onFocus: function onFocus() {
      return props.onFocus();
    },
    onChange: handleChangeIntro,
    value: intro,
    className: styles.input
  }), /*#__PURE__*/React.createElement(Button, {
    disabled: edgeDataLoading === true,
    loading: loading,
    onClick: handleClickMakeACall,
    type: "primary",
    className: styles.makeACall
  }, "Make a call"));
}
export default MakeACall;